<template>
	<div>
		<vx-tooltip text="Download pakbon" position="top">
			<vs-button id="downloadPackingSlipsButton" class="vs-con-loading__container" color="primary" @click.native="selectedDownloadPackingSlips">
				<font-awesome-icon :icon="['fas', 'file-pdf']" class="fa-icon" />
			</vs-button>
		</vx-tooltip>
	</div>
</template>

<script>
import apiClient from '@/services/apiClient';
import {format} from 'date-fns';

export default {
	props: {
		order_id: {
			required: true,
			type: Number,
		},
	},
	methods: {
		selectedDownloadPackingSlips() {
			this.startLoading();

			apiClient.get('orders/packagingslip/download', {
				params: {'order_id': this.order_id},
				responseType: 'blob'
			}).then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');

				link.href = url;
				link.setAttribute('download', 'pakbonnen-' + format(new Date(), 'Y-MM-dd_H:mm:ss') + '.pdf');
				document.body.appendChild(link);
				link.click();

				this.stopLoading();
			}).catch(error => {
				this.stopLoading();
			})
		},
		startLoading() {
			this.$vs.loading({
				container: '#downloadPackingSlipsButton',
				scale: 0.45
			})
		},
		stopLoading() {
			this.$vs.loading.close('#downloadPackingSlipsButton > .con-vs-loading')
		}
	}
}
</script>
